import React, { useState } from "react";
import { Table, Collapse, Button } from "reactstrap";
import PropTypes from "prop-types";
import formatCurrency from "constants/formatCurrency";
import formatDate from "constants/formatDate";

const AmanoReportTable = ({ locations }) => {
    const [expanded, setExpanded] = useState({});
    const [page, setPage] = useState({});
    const itemsPerPage = 10;

    const toggleExpand = (key) => {
        setExpanded((prev) => ({ ...prev, [key]: !prev[key] }));
    };

    const paginate = (arr, key) => {
        const currentPage = page[key] || 1;
        const start = (currentPage - 1) * itemsPerPage;
        return arr.slice(start, start + itemsPerPage);
    };

    const totalPages = (arr) => Math.max(1, Math.ceil(arr.length / itemsPerPage));

    return (
        <div className="overflow-x-auto">
            <Table bordered responsive className="align-middle table-nowrap">
                <thead className="table-light">
                    <tr>
                        <th>Location</th>
                        <th>Total Transactions</th>
                        <th>Total Fee</th>
                        <th>Total VAT</th>
                        <th>Total Net</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {locations.filter(item => item.transactions.length > 0).map((loc) => {
                        const totalFee = loc.transactions.reduce((sum, t) => sum + (parseFloat(t.fee) || 0), 0);
                        const totalVat = loc.transactions.reduce((sum, t) => sum + (parseFloat(t.vat) || 0), 0);
                        const totalNet = loc.transactions.reduce((sum, t) => sum + (parseFloat(t.fee - t.vat) || 0), 0);

                        const currentPage = page[loc.id] || 1;
                        const paginatedTxns = paginate(loc.transactions, loc.id);

                        return (
                            <React.Fragment key={loc.id}>
                                <tr>
                                    <td>{loc.name}</td>
                                    <td>{loc.transactions.length}</td>
                                    <td>${formatCurrency(totalFee)}</td>
                                    <td>${formatCurrency(totalVat)}</td>
                                    <td>${formatCurrency(totalNet)}</td>
                                    <td>
                                        {loc.transactions.length > 0 && (
                                            <Button
                                                className="button-gradient-bg"
                                                color="primary"
                                                size="sm"
                                                onClick={() => toggleExpand(loc.id)}
                                            >
                                                {expanded[loc.id] ? "Hide Transactions" : "View Transactions"}
                                            </Button>
                                        )}
                                    </td>
                                </tr>
                                <tr>
                                    <td colSpan={6} className="p-0 border-0">
                                        <Collapse isOpen={expanded[loc.id]}>
                                            <Table bordered size="sm" responsive className="mb-0 table-striped">
                                                <thead>
                                                    <tr>
                                                        <th>Date & Time</th>
                                                        <th>Fee</th>
                                                        <th>VAT</th>
                                                        <th>Net</th>
                                                        <th>Payment Mode</th>
                                                        <th>Receipt No</th>
                                                        <th>Sales Type</th>
                                                        <th>Ticket No</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {paginatedTxns.map((t) => (
                                                        <tr key={t.id}>
                                                            <td>{formatDate(t.date_time)}</td>
                                                            <td>${formatCurrency(t.fee)}</td>
                                                            <td>${formatCurrency(t.vat)}</td>
                                                            <td>${formatCurrency(t.fee - t.vat)}</td>
                                                            <td>{t.payment_mode}</td>
                                                            <td>{t.receipt_no}</td>
                                                            <td>{t.sales_type}</td>
                                                            <td>{t.ticket_no}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </Table>
                                            {loc.transactions.length > itemsPerPage && (
                                                <div className="d-flex justify-content-between align-items-center p-2">
                                                    <Button
                                                        color="secondary"
                                                        size="sm"
                                                        onClick={() =>
                                                            setPage((prev) => ({
                                                                ...prev,
                                                                [loc.id]: Math.max(1, currentPage - 1),
                                                            }))
                                                        }
                                                        disabled={currentPage === 1}
                                                    >
                                                        Previous
                                                    </Button>
                                                    <span>
                                                        Page {currentPage} of {totalPages(loc.transactions)}
                                                    </span>
                                                    <Button
                                                        color="secondary"
                                                        size="sm"
                                                        onClick={() =>
                                                            setPage((prev) => ({
                                                                ...prev,
                                                                [loc.id]: Math.min(
                                                                    totalPages(loc.transactions),
                                                                    currentPage + 1
                                                                ),
                                                            }))
                                                        }
                                                        disabled={currentPage === totalPages(loc.transactions)}
                                                    >
                                                        Next
                                                    </Button>
                                                </div>
                                            )}
                                        </Collapse>
                                    </td>
                                </tr>
                            </React.Fragment>
                        );
                    })}
                    {locations.length === 0 && (
                        <tr>
                            <td colSpan={6} className="text-center py-3">
                                No Amano transactions found
                            </td>
                        </tr>
                    )}
                </tbody>
            </Table>
        </div>
    );
};

AmanoReportTable.propTypes = {
    locations: PropTypes.array.isRequired,
};

export default AmanoReportTable;